module.exports = __webpack_public_path__ + "static/img/music_web.f52e47c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/images/code/music_web.jpeg
// module id = CyA1
// module chunks = 11